import axios from 'axios';
export const getVINDetails = async (vin, year) => {
  if(!vin){
    return false
  }
  const apiURL =  'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/'+vin+'?format=json&modelyear=' + year;

  try {
    const { data } = await axios.get(apiURL);
    return data;
  } catch (error) {
    console.error(error);
  }
};
